import React from 'react';
import noTasksIllustration from '../../static/img/no-tasks-illustration.svg';
import addIcon from '../../static/icons/gradient_add.svg';
import { Container, CreateTaskButton, Illustration, Message } from './style';

// The empty Current Tasks page from Figma 7621:43528 (JED-1272). Each page
// positions it under its own column headers.
export default function TasksEmptyState({ message, onCreateTask, className }) {
  return (
    <Container className={className}>
      <Illustration src={noTasksIllustration} alt="" />
      <Message>{message}</Message>
      {onCreateTask && (
        <CreateTaskButton type="button" onClick={onCreateTask}>
          <img src={addIcon} alt="" />
          Create Task
        </CreateTaskButton>
      )}
    </Container>
  );
}
